function set2fig(num) {
	var ret;
	if( num < 10 ) { ret = "0" + num; }
	else { ret = num; }
	return ret;
}
function showClock() {
	const month_english_list = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

	var nowTime  = new Date();
	var nowYear  = nowTime.getFullYear();
	var nowMonth = nowTime.getMonth() + 1;
	var nowDay   = nowTime.getDate();
	var monthEnglish =  month_english_list[nowMonth - 1];
	var dayOfWeek = nowTime.getDay() ;
	//var dayOfWeekStr = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ][dayOfWeek] ;
	var dayOfWeekStr = [ "日", "月", "火", "水", "木", "金", "土" ][dayOfWeek];
	
	var nowHour = set2fig( nowTime.getHours() );
	var nowMin  = set2fig( nowTime.getMinutes() );
	var nowSec  = set2fig( nowTime.getSeconds() );
	
	var date = nowYear + '年' + nowMonth + '月' + nowDay + '日（' + dayOfWeekStr + '）';
	//ar date = dayOfWeekStr+', '+monthEnglish+' '+nowDay+', '+nowYear
	var h_t  = nowHour + ':' + nowMin;
	
	document.querySelector('.js-clock-date').innerHTML = date;
	document.querySelector('.js-clock-h_t').innerHTML = h_t;
	//document.querySelector('.js-clock-s').innerHTML = nowSec;

}
setInterval(showClock,1000);